const isPrivateNetworkHost = (host) => {
    return (
        host == 'localhost' ||
        host == '127.0.0.1' ||
        host == '::1' ||
        /^10\./.test(host) ||
        /^192\.168\./.test(host) ||
        /^172\.(1[6-9]|2\d|3[0-1])\./.test(host)
    );
};

const resolveRuntimeEnvironment = ({ hostname, origin, protocol, env }) => {
    if (isPrivateNetworkHost(hostname)) {
        const apiRoot =
            hostname == 'localhost' || hostname == '127.0.0.1'
                ? env.VUE_APP_API_URL_DEV
                : `${protocol}//${hostname}:3000/api/`;

        return { apiRoot, environment: 'development' };
    }

    const hostedEnvironments = [
        {
            hostname: 'beta.app.ipacdashboard.com',
            origin: env.VUE_APP_URL_BETA,
            apiRoot: env.VUE_APP_API_URL_BETA,
            environment: 'beta',
        },
        {
            hostname: 'staging.app.ipacdashboard.com',
            origin: env.VUE_APP_URL_STAGING,
            apiRoot: env.VUE_APP_API_URL_STAGING,
            environment: 'staging',
        },
        {
            hostname: 'app.ipacdashboard.com',
            origin: env.VUE_APP_URL_PROD,
            apiRoot: env.VUE_APP_API_URL_PROD,
            environment: 'production',
        },
    ];

    const match = hostedEnvironments.find(
        (candidate) =>
            hostname == candidate.hostname ||
            (origin && candidate.origin && origin == candidate.origin)
    );

    if (match) {
        if (!match.apiRoot) {
            throw new Error(
                `Missing API configuration for ${match.environment} client host: ${hostname}`
            );
        }

        return { apiRoot: match.apiRoot, environment: match.environment };
    }

    throw new Error(`Unsupported public client host: ${hostname}`);
};

const isSquarePaymentsEnabled = (environment) => environment != 'staging';
const isSelfRegistrationEnabled = (environment) => environment != 'staging';

export {
    isPrivateNetworkHost,
    isSelfRegistrationEnabled,
    isSquarePaymentsEnabled,
    resolveRuntimeEnvironment,
};
